import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ResourcesContent from '../components/ResourcesContent';
// import Banner from '../components/Banner';
import './About.css';

const Resources = () => {
  return (
    <div className="resources-container" style={{ backgroundColor: "#edffee" }}>
        <Header />
        <ResourcesContent />
        <Footer />
    </div>
  );
};

export default Resources;
